<template>
  <div class="range_container">
    <div class="sliders_control">
      <input
        ref="fromSlider"
        id="fromSlider"
        type="range"
        :value="fromInput"
        :min="min"
        :max="max"
        :step="step"
        @input="controlFromSlider($refs.fromSlider, $refs.toSlider)"
        @mouseup="$emit('input', { to: toInput, from: fromInput })"
        @touchend="$emit('input', { to: toInput, from: fromInput })"
      />
      <input
        ref="toSlider"
        type="range"
        :value="toInput"
        :min="min"
        :max="max"
        :step="step"
        @input="controlToSlider($refs.fromSlider, $refs.toSlider)"
        @mouseup="$emit('input', { to: toInput, from: fromInput })"
        @touchend="$emit('input', { to: toInput, from: fromInput })"
      />
    </div>
    <div class="form_control">
      <div class="form_control_container">
        <span v-if="isCurrency">{{ fromInput | currency }}</span>
        <span v-else-if="percent">{{ fromInput + "%" }}</span>
        <span v-else>{{ fromInput }}</span>
      </div>
      <div class="form_control_container text-right">
        <span v-if="isCurrency">{{ toInput | currency }}</span>
        <span v-else-if="percent">{{ toInput + "%" }}</span>
        <span v-else>{{ toInput }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../../utils/event_bus";
export default {
  props: {
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    step: {
      type: Number,
    },
    from: {
      type: Number,
    },
    to: {
      type: Number,
    },
    isCurrency: {
      type: Boolean,
    },
    percent: {
      type: Boolean,
    },
  },
  data() {
    return {
      fromInput: this.from,
      toInput: this.to,
    };
  },
  methods: {
    getParsed(currentFrom, currentTo) {
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    },

    controlFromSlider(fromSlider, toSlider) {
      const [from, to] = this.getParsed(fromSlider, toSlider);
      this.fromInput = from > to ? to : from;
      this.fillSlider(
        fromSlider,
        toSlider,
        "#C6C6C6",
        from > to ? "#dd5b5b" : "#0694e6",
        toSlider
      );
    },

    controlToSlider(fromSlider, toSlider) {
      const [from, to] = this.getParsed(fromSlider, toSlider);
      this.toInput = to < from ? from : to;
      this.fillSlider(
        fromSlider,
        toSlider,
        "#C6C6C6",
        from > to ? "#dd5b5b" : "#0694e6",
        toSlider
      );
    },

    fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
      const rangeDistance = to.max - to.min;
      const fromPosition = from.value - to.min;
      const toPosition = to.value - to.min;

      if (fromPosition < toPosition) {
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
      } else {
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%, 
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }
    },
  },
  mounted() {
    EventBus.$on("MARKETPLACE_CLEAR_ACTIVE_FILTERS", () => {
      this.fromInput = this.min;
      this.toInput = this.max;
      this.$nextTick(() => {
        this.controlFromSlider(this.$refs.fromSlider, this.$refs.toSlider);
        this.controlToSlider(this.$refs.fromSlider, this.$refs.toSlider);
      });
    });
    this.fillSlider(
      this.$refs.fromSlider,
      this.$refs.toSlider,
      "#C6C6C6",
      "#0694e6",
      this.$refs.toSlider
    );
  },
};
</script>

<style lang="scss" scoped>
.range_container {
  @apply flex w-full flex-col space-y-4 pt-2;
}

.sliders_control {
  @apply relative flex items-center justify-center;
}

.form_control {
  @apply relative flex justify-between text-sm;
}

input[type="range"] {
  @apply pointer-events-none absolute  h-1 w-full appearance-none rounded bg-gray-400;
  &::-webkit-slider-thumb {
    @apply pointer-events-auto h-4 w-4 cursor-pointer appearance-none rounded-full bg-gray-300 shadow hover:bg-gray-50;
    &:active {
      box-shadow: inset 0 0 3px #387bbe, 0 0 9px #387bbe;
      -webkit-box-shadow: inset 0 0 3px #387bbe, 0 0 9px #387bbe;
    }
  }
  &::-moz-range-thumb {
    @apply pointer-events-auto h-4 w-4 cursor-pointer appearance-none rounded-full bg-gray-300 shadow;
  }
}

#fromSlider {
  height: 0;
  z-index: 1;
}
</style>
